import { useState } from 'react';

export type WorkflowStep = {
  id: number;
  title: string;
  isCompleted: boolean;
};

const useWorkflow = (initialSteps: string[]) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(1);
  const [steps, setSteps] = useState<WorkflowStep[]>(
    initialSteps.map((title, index) => ({
      id: index + 1,
      title,
      isCompleted: false,
    }))
  );

  const markStepComplete = (stepId: number) => {
    setSteps((prevSteps) =>
      prevSteps.map((step) =>
        step.id === stepId ? { ...step, isCompleted: true } : step
      )
    );
  };

  const nextStep = () => {
    markStepComplete(currentStepIndex);
    if (currentStepIndex < steps.length) {
      setCurrentStepIndex(currentStepIndex + 1);
    }
  };

  const previousStep = () => {
    if (currentStepIndex > 1) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  // Nueva función para ir a cualquier paso directamente
  const goToStep = (stepId: number) => {
    if (stepId >= 1 && stepId <= steps.length) {
      setCurrentStepIndex(stepId);
    }
  };

  const resetWorkflow = () => {
    setCurrentStepIndex(1);
    setSteps((prevSteps) =>
      prevSteps.map((step) => ({ ...step, isCompleted: false }))
    );
  };

  const isLastStep = currentStepIndex === steps.length;
  const stepTitles = steps.map(step => step.title);

  return {
    currentStep: currentStepIndex,
    steps: stepTitles,
    nextStep,
    previousStep,
    goToStep, // Exportamos la nueva función
    resetWorkflow,
    isLastStep,
    isStepCompleted: (stepIndex: number) => 
      steps.find(step => step.id === stepIndex)?.isCompleted || false
  };
};

export default useWorkflow;